function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.8333 5.81669C10.8333 2.82515 8.40821 0.400024 5.41667 0.400024C2.42512 0.400024 0 2.82515 0 5.81669C0 8.80823 2.42512 11.2334 5.41667 11.2334C6.75833 11.2334 7.99167 10.7417 8.94167 9.93336L9.16667 10.1584V10.8167L13.3333 14.9834L14.5833 13.7334L10.4167 9.56669H9.75833L9.53333 9.34169C10.3417 8.39169 10.8333 7.15836 10.8333 5.81669ZM1.66667 5.81669C1.66667 3.73336 3.33333 2.06669 5.41667 2.06669C7.5 2.06669 9.16667 3.73336 9.16667 5.81669C9.16667 7.90002 7.5 9.56669 5.41667 9.56669C3.33333 9.56669 1.66667 7.90002 1.66667 5.81669Z",
  fill: "#ACACAC"
});

var SvgLoop = function SvgLoop(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLoop, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/loop.d34d3ad5.svg";
export { ForwardRef as ReactComponent };